module.exports = __webpack_public_path__ + "static/media/icon_reservation_copy.aa638a45.svg";